module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('img', {
    class: _vm.isMobileClass,
    attrs: {
      "src": _vm.preview.web.path
    }
  }), _c('div', {
    staticClass: "mobile-preview"
  }, [_c('img', {
    class: _vm.isDesktopClass,
    attrs: {
      "src": _vm.preview.mobile.path
    }
  })]), _c('div', {
    staticClass: "row switcher"
  }, [_c('div', {
    staticClass: "col format-switcher"
  }, [_c('div', {
    staticClass: "button button-desktop",
    attrs: {
      "slot": "button-next"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.icons.getCreativePreview("desktop"))
    },
    on: {
      "click": function($event) {
        _vm.setMobilePreview(false)
      }
    },
    slot: "button-next"
  }), _c('div', {
    staticClass: "button button-mobile",
    attrs: {
      "slot": "button-next"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.icons.getCreativePreview("mobile"))
    },
    on: {
      "click": function($event) {
        _vm.setMobilePreview(true)
      }
    },
    slot: "button-next"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34f34226"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/custom-preview/CustomPreview.vue
// module id = 2032
// module chunks = 1